import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchDataDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import FormLoadingStateCst from "@components/FormLoadingStateCst";
import ModalCst from "@components/ModalCst";
import UserWizard from "../Wizard/UserWizard";
import { useSaveUser } from "../Wizard/useSaveUser";
import {
  CUSTOM_FIELD_KEYS,
  INITIAL_USER_WIZARD_DATA,
  UserWizardData,
} from "../Wizard/types";
import {
  CustomFieldsCatalog,
  UserCustomFieldsProvider,
} from "../Wizard/customFieldsContext";

const AddUser: React.FC = () => {
  const { id: corporateId = "" } = useParams();
  const navigate = useNavigate();
  const backTo = `/v2/corporate/${corporateId}/detail/users-groups`;
  const [submitting, setSubmitting] = useState(false);

  const { dataDetail: dataCustomFields } = useFetchDataDetail(
    `${ServicesURL.getCorporateCustomFields}?corporate_id=${corporateId}`,
    PagesID["corporate.customFields"],
  );

  const { outcome, openOutcome, setOpenOutcome, save } = useSaveUser({
    mode: "create",
    corporateId,
    initialStaticGroupIds: [],
  });

  const catalog: CustomFieldsCatalog = useMemo(() => {
    const raw = dataCustomFields?.catalog || {};
    const out: CustomFieldsCatalog = {};
    CUSTOM_FIELD_KEYS.forEach((k) => {
      if (raw[k]) out[k] = raw[k];
    });
    return out;
  }, [dataCustomFields]);

  const onComplete = async (data: UserWizardData) => {
    setSubmitting(true);
    try {
      await save(data);
    } finally {
      setSubmitting(false);
    }
  };

  if (!dataCustomFields) return <FormLoadingStateCst />;

  return (
    <UserCustomFieldsProvider catalog={catalog}>
      <UserWizard
        mode="create"
        initialData={INITIAL_USER_WIZARD_DATA}
        backTo={backTo}
        onComplete={onComplete}
        isCompleting={submitting}
      />
      <ModalCst
        open={openOutcome}
        setOpen={setOpenOutcome}
        typeOfModal="outcome"
        noToast
        disableBackdropClick
        data={{
          outcome,
          callBackSubmit: () => {
            setOpenOutcome(false);
            navigate(backTo);
          },
        }}
      />
    </UserCustomFieldsProvider>
  );
};

export default AddUser;
